import { useQuery } from '@tanstack/react-query';

import { showReview } from 'services/api/reviews';

export function useReview(reviewId: string, queryKeys: any, queryParams: any) {
  const { data: review, isPending } = useQuery({
    queryKey: queryKeys.show({ id: reviewId }),
    queryFn: () => showReview(queryParams.show(reviewId)),
    enabled: !!reviewId,
  });

  return {
    review,
    loading: isPending,
  };
}
